import axios from 'axios';

// The CloudFront firewall rejects query strings over ~2 KB with a 403, so longer pass-through reads
// are sent as a POST carrying the query string; server/api/sharetribeApiProxy.js replays them as GET.
export const MAX_QUERY_LENGTH = 1500;
export const QUERY_IN_BODY_HEADER = 'X-Promotix-Query-In-Body';

const serializeParams = config => {
  const { params, paramsSerializer } = config;
  const serialize =
    typeof paramsSerializer === 'function' ? paramsSerializer : paramsSerializer?.serialize;
  return serialize ? serialize(params) : new URLSearchParams(params).toString();
};

// The SDK bundles its own axios copy, and each copy's AxiosHeaders drops every header of the other
// copy's AxiosHeaders instance, so request and response headers always cross as plain objects.
const plainHeaders = headers =>
  headers && typeof headers.toJSON === 'function' ? headers.toJSON() : { ...headers };

const withPlainResponseHeaders = promise =>
  promise.then(
    response => ({ ...response, headers: plainHeaders(response.headers) }),
    error => {
      if (error && error.response) {
        error.response = { ...error.response, headers: plainHeaders(error.response.headers) };
      }
      throw error;
    }
  );

/**
 * Axios adapter for the browser SDK when it talks to the pass-through at `proxyBaseUrl`.
 */
export const createLongQueryAdapter = (
  proxyBaseUrl,
  defaultAdapter = axios.getAdapter(axios.defaults.adapter)
) => config => {
  const headers = plainHeaders(config.headers);
  const isProxyRead =
    (config.method || 'get').toLowerCase() === 'get' &&
    config.params &&
    (config.baseURL || '').startsWith(proxyBaseUrl);
  const query = isProxyRead ? serializeParams(config) : '';
  if (query.length <= MAX_QUERY_LENGTH) {
    return withPlainResponseHeaders(defaultAdapter({ ...config, headers }));
  }

  return withPlainResponseHeaders(
    defaultAdapter({
      ...config,
      method: 'post',
      params: undefined,
      data: query,
      headers: {
        ...headers,
        'Content-Type': 'text/plain;charset=UTF-8',
        [QUERY_IN_BODY_HEADER]: '1',
      },
    })
  );
};
